"use strict";

import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime-corejs3/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { STATIC_MFE_URL } from '@autoguru/global-configs';
import { buildAssetUrl, getMountPointElement, validateMountTarget } from '../lib';
// A generic function to create an HTML element - only called in browser
const createElement = (type, asset, mfeAppName, STATIC_MFE_URL) => {
  const element = document.createElement(type);
  if (type === 'link') {
    const linkElement = element;
    linkElement.rel = 'stylesheet';
    linkElement.href = buildAssetUrl({
      asset,
      mfeAppName,
      staticMFEUrl: STATIC_MFE_URL
    });
    return linkElement;
  }
  if (type === 'script') {
    const scriptElement = element;
    scriptElement.type = 'module';
    scriptElement.src = buildAssetUrl({
      asset,
      mfeAppName,
      staticMFEUrl: STATIC_MFE_URL
    });
    return scriptElement;
  }
  throw new Error(`Unsupported element type: ${type}`);
};

// Factory function to create MFEComponent class - defined here to avoid SSR issues
// The class extends HTMLElement which doesn't exist during server-side rendering
const createMFEComponentClass = () => {
  let MFEComponent = /*#__PURE__*/function (_HTMLElement) {
    function MFEComponent(...args) {
      var _this;
      _this = _HTMLElement.call.apply(_HTMLElement, [this].concat(args)) || this;
      _defineProperty(_this, "shadowRootRef", null);
      _defineProperty(_this, "shouldUseShadowRoot", true);
      _defineProperty(_this, "mountPoint", null);
      _defineProperty(_this, "loaded", false);
      _defineProperty(_this, "mfeAppName", null);
      _defineProperty(_this, "scriptElements", new Set());
      _defineProperty(_this, "linkElements", new Set());
      _defineProperty(_this, "portalContainer", null);
      _defineProperty(_this, "mountAttempts", 0);
      _defineProperty(_this, "loadingTimeout", null);
      _defineProperty(_this, "MAX_MOUNT_ATTEMPTS", 10);
      return _this;
    }
    _inheritsLoose(MFEComponent, _HTMLElement);
    var _proto = MFEComponent.prototype;
    _proto.createPortalContainer = function createPortalContainer() {
      if (!this.shouldUseShadowRoot) {
        return null;
      }
      if (!this.portalContainer) {
        this.portalContainer = document.createElement('div');
        this.portalContainer.className = `${this.mfeAppName}-portal-container`;
        document.body.appendChild(this.portalContainer);
      }
      return this.portalContainer;
    };
    _proto.applyStylesToPortal = function applyStylesToPortal(stylesheetLink) {
      if (!this.shouldUseShadowRoot || !this.portalContainer) {
        return;
      }
      const portalLink = stylesheetLink.cloneNode(true);
      this.portalContainer.appendChild(portalLink);
      this.linkElements.add(portalLink);
    };
    _proto.getAssetTarget = function getAssetTarget() {
      return this.shouldUseShadowRoot && this.shadowRootRef ? this.shadowRootRef : document.head;
    };
    _proto.attemptMount = function attemptMount() {
      var _window;
      if (this.mountAttempts >= this.MAX_MOUNT_ATTEMPTS) {
        console.warn(`Failed to mount ${this.mfeAppName} after ${this.MAX_MOUNT_ATTEMPTS} attempts`);
        return;
      }

      // Try to get the mount function using the utility
      const mountFunction = this.mfeAppName ? (_window = window[`__MOUNT__${this.mfeAppName}`]) === null || _window === void 0 ? void 0 : _window.mountFunction : null;
      let isValidateMountTarget = false;
      if (mountFunction && this.mfeAppName) {
        const mountPoint = getMountPointElement(this.mfeAppName);
        isValidateMountTarget = mountPoint ? validateMountTarget(() => mountPoint) : false;
      }
      if (typeof mountFunction === 'function' && isValidateMountTarget) {
        mountFunction();
        return;
      }
      this.mountAttempts++;

      // If mount function not found, try again after a short delay
      this.loadingTimeout = setTimeout(() => this.attemptMount(), 200);
    };
    _proto.loadMFE = function loadMFE(mfeAppName, manifest) {
      this.mfeAppName = mfeAppName;

      // Create portal container for modals (only in shadow mode)
      if (this.shouldUseShadowRoot) this.createPortalContainer();

      // If already loaded, trigger remount
      if (this.loaded) {
        this.attemptMount();
        return;
      }
      let lastJsAsset = null;
      let lastCssAsset = null;
      const assetTarget = this.getAssetTarget();
      for (const asset of manifest.assets.js) {
        const scriptElement = createElement('script', asset, mfeAppName, STATIC_MFE_URL);
        assetTarget.appendChild(scriptElement);
        this.scriptElements.add(scriptElement);
        lastJsAsset = scriptElement;
      }
      for (const asset of manifest.assets.css) {
        const stylesheetLink = createElement('link', asset, mfeAppName, STATIC_MFE_URL);
        assetTarget.appendChild(stylesheetLink);
        if (this.shouldUseShadowRoot) {
          this.applyStylesToPortal(stylesheetLink);
        }
        this.linkElements.add(stylesheetLink);
        lastCssAsset = stylesheetLink;
      }

      // Create a one-time-only onload handler
      const onMainAssetsLoaded = () => {
        var _manifest$chunks;
        // If already loaded, prevent multiple executions
        if (this.loaded) {
          return;
        }

        // Immediately remove event listeners to prevent multiple triggers
        if (lastJsAsset) {
          lastJsAsset.onload = null;
        }
        if (lastCssAsset) {
          lastCssAsset.onload = null;
        }
        this.loaded = true;
        // If already loaded, trigger remount
        if (this.loaded) {
          this.attemptMount();
        }
        if (Array.isArray((_manifest$chunks = manifest.chunks) === null || _manifest$chunks === void 0 ? void 0 : _manifest$chunks.css)) {
          const chunkAssetTarget = this.getAssetTarget();
          for (const asset of manifest.chunks.css) {
            const chunkLink = createElement('link', asset, mfeAppName, STATIC_MFE_URL);
            chunkAssetTarget.appendChild(chunkLink);
            if (this.shouldUseShadowRoot) {
              this.applyStylesToPortal(chunkLink);
            }
            this.linkElements.add(chunkLink);
          }
        }
      };

      // Only set up onload handlers if assets aren't already loaded
      if (!this.loaded) {
        if (lastJsAsset && lastCssAsset) {
          // Separate handlers to avoid multiple triggers
          lastJsAsset.onload = () => {
            if (lastJsAsset.onload) {
              lastJsAsset.onload = null;
              // Only trigger if CSS is also loaded
              if (!lastCssAsset.onload) {
                onMainAssetsLoaded();
              }
            }
          };
          lastCssAsset.onload = () => {
            if (lastCssAsset.onload) {
              lastCssAsset.onload = null;
              // Only trigger if JS is also loaded
              if (!lastJsAsset.onload) {
                onMainAssetsLoaded();
              }
            }
          };
        } else if (lastJsAsset) {
          lastJsAsset.onload = () => {
            lastJsAsset.onload = null;
            onMainAssetsLoaded();
          };
        } else if (lastCssAsset) {
          lastCssAsset.onload = () => {
            lastCssAsset.onload = null;
            onMainAssetsLoaded();
          };
        } else {
          onMainAssetsLoaded();
        }
      }
    };
    _proto.connectedCallback = function connectedCallback() {
      const useShadowRootAttr = this.getAttribute('use-shadow-root');
      this.shouldUseShadowRoot = useShadowRootAttr === null || useShadowRootAttr === 'true';
      if (this.shouldUseShadowRoot && !this.shadowRootRef) {
        this.shadowRootRef = this.attachShadow({
          mode: 'open'
        });
      }
      const mfeAppName = this.getAttribute('mfe-app-name');
      const manifestAttr = this.getAttribute('manifest');
      const manifest = manifestAttr ? JSON.parse(manifestAttr) : null;
      if (!mfeAppName || !manifest) {
        return;
      }

      // Create mount point if it doesn't exist
      if (!this.mountPoint) {
        this.mountPoint = document.createElement('div');
        this.mountPoint.id = manifest.mountDOMId || '';
        this.mountPoint.className = manifest.mountDOMClass || '';
        if (this.shouldUseShadowRoot && this.shadowRootRef) {
          this.shadowRootRef.appendChild(this.mountPoint);
        } else {
          this.appendChild(this.mountPoint);
        }
      }
      this.loadMFE(mfeAppName, manifest);
    };
    _proto.disconnectedCallback = function disconnectedCallback() {
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      // Clean up all script and link elements
      for (const script of Array.from(this.scriptElements)) {
        script.remove();
      }
      for (const link of Array.from(this.linkElements)) {
        link.remove();
      }
      this.scriptElements.clear();
      this.linkElements.clear();

      // Clean up portal container
      if (this.portalContainer) {
        this.portalContainer.remove();
        this.portalContainer = null;
      }

      // Clean up mount point
      if (this.mountPoint) {
        this.mountPoint.remove();
        this.mountPoint = null;
      }
      this.loaded = false;
      this.mountAttempts = 0;
    };
    return MFEComponent;
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  return MFEComponent;
};
export const createDynamicMFEComponentClass = () => {
  // Must return a new class each time - Web Components API doesn't allow
  // the same constructor to be registered with different element names
  const MFEComponent = createMFEComponentClass();
  return /*#__PURE__*/function (_MFEComponent2) {
    function _class() {
      return _MFEComponent2.apply(this, arguments) || this;
    }
    _inheritsLoose(_class, _MFEComponent2);
    return _class;
  }(MFEComponent);
};